import type { $Fetch, FetchOptions } from 'ofetch';
import { useUserStore } from '~/stores/user';

/*
 The FetchFactory acts as a wrapper around an HTTP client.
 It encapsulates the functionality for making API requests asynchronously
 through the call function, utilizing the provided HTTP client.
*/
declare global {
  interface FetchResponse<T> {
    data: T;
    success: boolean;
    message: string;
    pagination: Pagination;
  }

  interface Pagination {
    total: number;
    perPage: number;
    currentPage: number;
    lastPage: number;
    from: number;
    to: number;
  }
}


class FetchFactory<T> {
  private $fetch: $Fetch;

  constructor(fetcher: $Fetch) {
    this.$fetch = fetcher;
  }

  /**
   * The HTTP client is utilized to control the process of making API requests.
   * @param method the HTTP method (GET, POST, ...)
   * @param url the endpoint url
   * @param data the body data
   * @param fetchOptions fetch options
   * @returns
   */
  async call(
    url: string,
    fetchOptions?: FetchOptions<'json', string>
  ): Promise<FetchResponse<T>> {
    const userStore = useUserStore();

    try {
      return this.$fetch<FetchResponse<T>>(
        url,
        {
          ...fetchOptions,
          headers: {
            "Authorization": `Bearer ${useCookie('access_token').value}`,
          },
        }
      );
    } catch (error: any) {
      if (error.response?.status === 401) {
        userStore.logout();
      }
      if (error.response?._data) {
        return error.response._data;
      }

      throw error;
    }
  }
}

export default FetchFactory;
